export default function initRoleTyping() {
  const el = document.getElementById("roleText");
  if (!el) return;

  const roles = [
    "Machine Learning Craftsman",
    "Software Engineer",
    "AI Builder",
    "Backend Dev",
    "Data Scientist",
  ];

  let roleIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let currentText = "";

  const TYPING_SPEED = 80;
  const DELETING_SPEED = 40;
  const PAUSE_AFTER_TYPED = 2500;
  const PAUSE_AFTER_DELETED = 400;

  function tick() {
    const fullText = roles[roleIndex];

    if (isDeleting) {
      currentText = fullText.substring(0, charIndex - 1);
      charIndex--;
    } else {
      currentText = fullText.substring(0, charIndex + 1);
      charIndex++;
    }

    el.textContent = currentText;

    let nextDelay = isDeleting ? DELETING_SPEED : TYPING_SPEED;

    if (!isDeleting && charIndex === fullText.length) {
      nextDelay = PAUSE_AFTER_TYPED;
      isDeleting = true;
    } else if (isDeleting && charIndex === 0) {
      isDeleting = false;
      roleIndex = (roleIndex + 1) % roles.length;
      nextDelay = PAUSE_AFTER_DELETED;
    }

    setTimeout(tick, nextDelay);
  }

  setTimeout(tick, 1500);
}
